import { Box, Tooltip } from "@mui/material";
import { memo } from "react";
import { PermissionControl } from "../Permission";
import {
  StyledIconButton,
  StyledUplaodIcon,
  StyledDownloadIcon,
  AddOne,
} from "../styled/AddButton";

interface ActionButtonsProps {
  role: any;
  permissions: any;
  handleClickToUpload: () => void;
  handleOpen: () => void;
  handleClickToCreate: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  role,
  permissions,
  handleClickToUpload,
  handleOpen,
  handleClickToCreate,
}) => {
  const PLAYER_TEXT = "Player";

  // console.log("Action bar");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: { xs: "10px", sm: "20px", md: "30px" },
        alignItems: "center",
      }}
    >
      <PermissionControl
        permissionPath={permissions.pages.players.create}
        role={role}
        route={false}
      >
        <Tooltip
          title={`Bulk Upload  ${PLAYER_TEXT + permissions}`}
          placement='bottom'
        >
          <StyledIconButton
            aria-label='add-multiple'
            onClick={handleClickToUpload}
            edge='end'
            background='transparent'
            shadow='true'
          >
            <StyledUplaodIcon />
          </StyledIconButton>
        </Tooltip>
      </PermissionControl>

      <PermissionControl
        permissionPath={permissions.pages.players.access}
        role={role}
        route={false}
      >
        <Tooltip title={`Bulk Generate ${PLAYER_TEXT}s`} placement='bottom'>
          <StyledIconButton
            aria-label='add-multiple'
            onClick={handleOpen}
            edge='end'
          >
            <StyledDownloadIcon />
          </StyledIconButton>
        </Tooltip>{" "}
      </PermissionControl>
      <PermissionControl
        permissionPath={permissions.pages.players.create}
        role={role}
        route={false}
      >
        <Tooltip title={`Create New ${PLAYER_TEXT}`} placement='bottom'>
          <StyledIconButton
            aria-label='add'
            onClick={handleClickToCreate}
            edge='end'
          >
            <AddOne />
          </StyledIconButton>
        </Tooltip>
      </PermissionControl>
    </Box>
  );
};

export default ActionButtons;
